// ?redirect_to= is set by our own links (the landing page's Buy button,
// ProtectedRoute), but anyone can put anything in it. Only a path on this
// site is followed: '/x' yes, '//evil.com', '/\evil.com' or a full URL no.

const BASE = "https://same-origin.invalid";

/** `raw` when it is a same-origin path, else null. */
export function safeRedirectPath(raw: string | null | undefined): string | null {
  if (typeof raw !== "string" || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) {
    return null;
  }
  // The URL parser drops tabs and newlines, so '/\t/evil.com' is '//evil.com'
  // to a browser: resolve it the way the browser would and compare origins.
  try {
    return new URL(raw, BASE).origin === BASE ? raw : null;
  } catch {
    return null;
  }
}
